// Scanner PDF no navegador (0.49): as fotos vêm do seletor de arquivos (no celular ele já oferece a câmera).
// As imagens ficam na memória desta página enquanto ela estiver aberta: guarde o PDF (baixar, Drive ou OneDrive).

export const NO_NAVEGADOR = true;
export const temScannerSistema = () => false;
export const temTratamento = () => true;
export async function escanearSistema(_max?: number): Promise<string[] | null> { return null; }

function escolher(multiplo: boolean, camera: boolean): Promise<globalThis.File[]> {
  return new Promise(res => {
    const inp = document.createElement('input');
    inp.type = 'file'; inp.accept = 'image/*'; inp.multiple = multiplo;
    if (camera) inp.setAttribute('capture', 'environment');
    inp.onchange = () => res(Array.from(inp.files ?? []));
    inp.click();
  });
}
export async function escolherFotos(camera = false): Promise<string[]> {
  const fs = await escolher(!camera, camera);
  return fs.filter(f => f.size <= 25 * 1024 * 1024).slice(0, 40).map(f => URL.createObjectURL(f));
}

export const tamanhoDe = (uri: string) => new Promise<{ w: number; h: number }>((ok, erro) => {
  const im = new window.Image(); im.onload = () => ok({ w: im.naturalWidth, h: im.naturalHeight }); im.onerror = erro; im.src = uri;
});

export async function lerBytes(uri: string): Promise<Uint8Array> {
  return new Uint8Array(await (await fetch(uri)).arrayBuffer());
}

const urls = new Map<string, string>();
export async function gravar(doc: string, nome: string, bytes: Uint8Array): Promise<string> {
  const chave = doc + '/' + nome;
  const velho = urls.get(chave); if (velho) URL.revokeObjectURL(velho);
  const u = URL.createObjectURL(new Blob([bytes as BlobPart], { type: 'image/jpeg' }));
  urls.set(chave, u);
  return u;
}
export function apagarArquivo(uri?: string) {
  if (!uri) return;
  for (const [k, v] of urls) if (v === uri) { URL.revokeObjectURL(v); urls.delete(k); }
}
export function apagarPastaDoc(doc: string) {
  for (const [k, v] of urls) if (k.startsWith(doc + '/')) { URL.revokeObjectURL(v); urls.delete(k); }
}
export const existeLocal = (uri?: string) => !!uri && [...urls.values()].includes(uri);

// cada abertura da página é um "aparelho": ao recarregar, as imagens já não estão aqui
const sessao = 'web-' + Math.random().toString(36).slice(2, 10);
export const aparelhoScan = async () => sessao;

export const pastaAtual = async (): Promise<string | null> => null;
export const escolherPasta = async (): Promise<string | null> => null;
export async function gravarNaPasta(_nome: string, _bytes: Uint8Array, _perguntar = true, _mime = 'application/pdf'): Promise<{ pasta: string; uri: string } | null> { return null; }
